import React from "react";
import Box from "@mui/material/Box";

type IconProps = {
  path: string;
  alt: string;
  style?: Object;
};

export default function Icon(props: IconProps) {
  const { path, alt, style } = props;

  return (
    <Box sx={{ m: 1 }}>
      <img
        src={`/images/${path}`}
        alt={alt}
        style={{ maxWidth: "100px", maxHeight: "100px", ...style }}
      />
    </Box>
  );
}
